/**
 * 不存在展示
 */
const NULL = '/'
// 明拍事故类型
const AccidentTypes = ["碰撞", "水淹", "报废", "二手车", "盗抢", '火烧'];
// 暗拍二手车事故类型
const HiddenUsedCarAccidentTypes = ["碰撞", "水淹", "报废", "二手车", "盗抢", '火烧', '抵押车'];

/**
 * 事故类型 0碰撞 1水淹 2报废 3二手车 4盗抢 多个类型逗号分隔
 */
/**
 * 事故类型
 */
export const ACCIDENTTYPES = AccidentTypes.map((item, index) => {
    return {
        label: item, value: String(index)
    }
})
/**
 * 暗拍二手车事故类型
 */
export const HiddenUsedCarAccident = HiddenUsedCarAccidentTypes.map((item, index) => {
    return {
        label: item, value: String(index)
    }
})
/**
 * 获取事故类型label ,拼接
 * @param {*} value
 */
export const handleGetAccidentTypesLabel = (value = "") => {
    if (!value) {
        return NULL;
    }
    let valueArr = value.split(',');
    let str = valueArr.filter(item => item).map((item) => {
        return AccidentTypes[item]
    }).join(',')
    return str ? str : NULL;
}


// 1委托 2保全  3保全失败  4整备 5待上拍 16下拍 7流拍 10待付款 11待提车 12待过户 9已过户
/**
 * 委托状态 label 为前台展示 title为后端给的说明
 */
export const DELEGATESTATUS = [
    {
        label: '待委托',
        title: "委托",
        value: 1
    },
    {
        label: '待保全',
        title: "保全",
        value: 2
    },
    {
        label: '保全失败',
        title: "保全失败",
        value: 3
    },
    {
        label: '待整备',
        title: "整备",
        value: 4
    },
    {
        label: '待上拍',
        title: "待上拍",
        value: 5
    },
    {
        label: '下拍',
        title: "下拍",
        value: 16
    },
    {
        label: '待付款',
        title: "待付款",
        value: 10
    },
    {
        label: '待过户',
        title: "待过户",
        value: 12
    },
    {
        label: '已过户',
        title: "已过户",
        value: 9
    }

]

/**
 * 获取委托状态label
 * @param {*} value
 */
export const handleGetDelegateStatusLabel = (value) => {
    if (!value) {
        return '/'
    }
    let find = DELEGATESTATUS.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 是否期车
 */
export const ISPERIODIC = [
    {label: "是", value: 1},
    {label: "否", value: 0}
];
/**
 * 获取期车状态
 * @param {*} value
 * @returns
 */
export const handleGetIsPeriodicLabel = (value) => {
    if (value == undefined || value == null) {
        return '/'
    }
    let find = ISPERIODIC.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 费用类型
 */
export const COSTTYPE = [
    {label: "停车费", value: 1},
    {label: "4S店", value: 2},
    {label: "修理厂", value: 3},
    {label: "其他", value: 4},
];
/**
 * 获取费用类型
 * @param {*} value
 * @returns
 */
export const handleGetCostypeLabel = (value) => {
    let find = COSTTYPE.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 默认表单数据
 */
export const DEFAULTCARFORMDATA = {
    isPlanCar: '',
    institutionUserId: "",
    isScrap: "",
    id: "",
    carType: "",
    user: "",
    phone: "",
    isF: "",
    insurer: "",
    name: "",
    time: "",
    institution: "",
    location: "",
    lossName: "",
    lossPhone: "",
    masterName: "",
    masterPhone: "",
    isCost: "",
    price: "",
    costType: "",
    notes: "",
    otherPhotos: "",
    initialTime: "",
    vin: "",
    type: 1,
    entrust: null,
    areaId: '',
    inquireNumber: '',
    isPrice: 1,
    isVariation: 1,
    carUpbeatId: null,
    isOnePrice: 0,
    institutionAddress: '',
    warehouseId: ''
}


/**
 * 新增/修改用户 默认数据
 */
export const DEFAULTUSERFORMDATA = {
    "id": "",
    "username": "",
    "password": "",
    "nickname": "",
    "phone": "",
    "userTruename": "",
    "identityCard": "",
    "identityCardValidity": "",
    "institutionId": "",
    "roleId": "",
    "ruleId": "",
    "state": null,
    "emergencyName": "",
    "emergencyPhone": "",
    "mailingAddress": "",
    "isAppVip": 0,
    // 默认的下拉id
    "optionsId": 1,
    "sfzzmzurl": "", //身份证正面照
    "sfzzmyurl": "", //身份证反面照
    "csrq": null,//出生日期
    "nl": null,//年龄
    "xl": "",//学历
    "hj": "",//户籍
    "hy": "",//婚姻状况
    "zz": "",//职责
    "type":"3"//用户类型
}


/**
 * 协议签字
 */
export const AGREEMENTTYPE = [
    {label: "车主", value: 1},
    {label: "非车主", value: 2},
    {label: "公司", value: 3},
];
/**
 * 获取协议签字label
 * @param {*} value
 * @returns
 */
export const handleGetAgreementTypeLabel = (value) => {
    let find = AGREEMENTTYPE.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 个人费用审核状态
 * 0 未报、1待审、2已审、3退回
 */
export const USERSTATE = [
    {label: "未提交", value: 0},
    {label: "待审核", value: 1},
    {label: "已审核", value: 2},
    {label: "退回", value: 3},
];
/**
 * 获取个人费用审核状态
 * @param {*} value
 * @returns
 */
export const headquartersPersonalAudit = (value) => {
    let find = USERSTATE.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 个人人人审核
 * @param {*} value
 * @returns
 */
export const headPersonalAdit = (value) => {
    let find = USERSTATE.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 派工状态
 */
export const ISTOWCREW = [
    {label: "是", value: 1},
    {label: "否", value: 2},
];
/**
 * 获取派工状态
 * @param {*} value
 * @returns
 */
export const handleGetIsTowCrewLabel = (value) => {
    let find = ISTOWCREW.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 交通工具
 */
export const TRANSPORTATION = [
    {label: "出租车", value: "出租车"},
    {label: "网约车", value: "网约车"},
    {label: "地铁", value: "地铁"},
];
/**
 * 获取交通工具
 */
export const handleGetTRANSPORTATIONLabel = (value) => {
    let find = TRANSPORTATION.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 付款类型
 */
export const PAYMENTTYPE = [
    {label: "公司垫付", value: 0},
    {label: "会员交款", value: 1},
];
/**
 * 获取付款类型
 * @param {*} value
 * @returns
 */
export const handleGetPaymentTypeLabel = (value) => {
    let find = PAYMENTTYPE.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 个人费用表单默认数据
 */
export const DEFAULT_USERFORMDATA = {
    "outTime": "", //外出时间
    "endTime": "", //结束时间
    "hotelCosts": [
        // {
        //   "hotelDays": 12, //住宿天数
        //   "onedayPrice": 50 //单天房价
        // }
    ], //住宿费详情
    "travelCosts": [
        // {
        //   "travelTool": "travelTool", //交通工具
        //   "startPosition": "travelTool", //起点
        //   "endPosition": "endPosition", //终点
        //   "travelCostPrice": 100 //交通价格
        // }
    ], //交通费详情
    "trainCosts": [
        // {
        //   "trainStartPosition": "start", //火车起点
        //   "trainEndPosition": "end", //火车终点
        //   "trainCostPrice": 100 //火车价格
        // }
    ], //火车费详情
    "otherCosts": [
        // {
        //   "otherContent": "notes", //其他费用内容
        //   "otherCostPrice": 100, //其他费用价格
        //   "notes": "备注" //备注
        // }
    ] //其他费用详情
}


/**
 * 拖车费用默认数据
 */
export const TRAILER_DATA = {
    "maintainId": "", //保全id
    "start": "", //起点
    "end": "", //终点
    "forkliftPrice": 0, //叉车费用
    "garagePrice": 0, //4s店/修理厂费用
    "parkingPrice": 0, //停车费用
    "otherPrice": 0, //其他费用
    "startingPrice": 0, //起步费
    "moreKilometer": "0", //超公里数
    "everyMore": 0, //超每公里/元
    "notes": "" //备注
}


/**
 * 手续状态
 */
export const PROCEDURESTATE = [
    {label: "齐全", value: 1},
    {label: "不齐全", value: 2},
]

/**
 * 获取手续状态
 * @param {*} value
 * @returns
 */
export const handleGetProcedureStateLabel = (value) => {
    let find = PROCEDURESTATE.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 是否贷款
 */
export const ISLOAN = [
    {label: "是", value: 1},
    {label: "否", value: 2},
]
export const handleGetIsLoanLabel = (value) => {
    let find = ISLOAN.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 是否拆解 isDismantling
 */
export const ISDISMANTLING = [
    {label: "是", value: 1},
    {label: "否", value: 2},
]
export const handleGetIsDismantlingLabel = (value) => {
    let find = ISDISMANTLING.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 是或者否
 */
export const ISORNOT = [
    {label: "是", value: 1},
    {label: "否", value: 2},
]
export const handleGetIsOrNotLabel = (value) => {
    let find = ISORNOT.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 是否有违章
 */
export const ISVIOLATION = [
    {label: "不详", value: 0},
    {label: "是", value: 1},
    {label: "否", value: 2},
]
/**
 * 获取是否有违章
 * @param {*} value
 * @returns
 */
export const handleGetIsViolationLabel = (value) => {
    let find = ISVIOLATION.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 不详 是 否
 */
export const ISUNKNOWN = [
    {label: "不详", value: 0},
    {label: "是", value: 1},
    {label: "否", value: 2},
]
export const handleGetIsUnknownLabel = (value) => {
    let find = ISUNKNOWN.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 整备费用默认数据
 */
export const SERVICING_DATA = {
    "servicingCostProject": [
        {
            "project": "", //整备项目
            "price": 0 //价格
        },
    ], //整备项目 + 价格
    "servicingImg": [
        // "http://example.com/image1.jpg",
        // "http://example.com/image2.jpg",
        // "http://example.com/image3.jpg"
    ], //车辆整备照片
    "cost": [
        // "receipt1.jpg",
        // "receipt2.jpg",
        // "receipt3.jpg"
    ] //车辆费用
}


/**
 * 奖励申请默认参数数据
 */
export const REWARDAPPLY_DATA = {
    "type": 1, //1  保全降价奖励 2 个人费用
    "priceCause": "",
    "price": 0, //降价金额
    "photos": "",
    "userId": "", //申请人id
    "maintainId": "", //保全id
    tailState: null
}


/**
 * 降价原因
 */
export const LOWREASON = [
    {label: "二次事故", value: "二次事故"},
    {label: "车架号受损", value: "车架号受损"},
    {label: "其他", value: "其他"},
]
/**
 * 获取降价原因
 */
export const handleGetlowReasonLabel = (value) => {
    let find = LOWREASON.find((item) => item.value == value);
    return find ? find.label : NULL
}

/**
 * 委托方
 * 下拉框，选项包括：单位、个人。
 */
export const ENTRUSTINGPARTY = [
    {label: "单位", value: "1"},
    {label: "个人", value: "2"},
]

/**
 * 审核状态
 * 0未提交 1.待审核 2.审核中 3.审核通过 4.已驳回
 */
export const AUDITSTATUS = [
    {label: "未提交", value: 0},
    {label: "待审核", value: 1},
    {label: "审核中", value: 2},
    {label: "审核通过", value: 3},
    {label: "已驳回", value: 4},
]
/**
 *  获取审核状态
 * @param {*} value
 * @returns
 */
export const handleGetAuditStatusLabel = (value) => {
    let find = AUDITSTATUS.find((item) => item.value == value);
    return find ? find.label : NULL
}


/**
 * 机构、总部审核
 * 0待审核 1未通过 2通过 3驳回
 * @param {*} type
 * @returns
 */
export const agencyAndHeadquarters = (type) => {
    // 0未提交 1.待审核 2.审核中 3.审核通过 4.已驳回
    switch (type) {
        case 0:
          return "未提交";
        case 1:
            return "待审核";
        case 2:
            return "审核中";
        case 3:
            return "审核通过";
        case 4:
            return "已退回";
        case 5:
            return "已完成";
        default:
            return '未提交'
    }
}

/**
 * 0待审核 1审核成功 2审核失败
 */
export const handleStatus = (status) => {
    switch (status) {
        case 0:
            return "待审核";
        case 1:
            return "审核成功";
        case 2:
            return "审核失败";
        default:
            return "/";
    }
};


/**
 * 拖车费用审核
 * @param {*} type
 * @returns
 */
export const towingFeeAudit = (type) => {
    // 拖车是否自审 1 已审核 2 未审核 3审核失败
    switch (type) {
        case 1:
            return "已审核";
        case 2:
            return "未审核";
        case 3:
            return "审核失败";
        default:
            return '/'
    }
}
// 总部审核
export const headquartersAudit = (type) => {
    //  总部审核 1 未完成 2 总公司确定 3 审核失败
    switch (type) {
        case 1:
            return "未完成";
        case 2:
            return "总公司确定";
        case 3:
            return "审核失败";
        default:
            return '/'
    }
}


export const handleAuditStatus = (status) => {
    // 0未提交 / 1待审核 / 2已通过 / 3已驳回
    switch (status) {
        // case 0:
        //   return "未提交";
        case 1:
            return "待审核";
        case 2:
            return "已通过";
        case 3:
            return "已驳回";
        default:
            return '未提交'
    }

}

/**
 * 车辆状态
 * 待委托、待保全、待整备、待上拍、已上拍、待交款、待提车、待过户
 */
export const CARSTYPE = (type) => {
    // 1委托 2保全 3保全失败 4整备 5待上拍 6上拍 7 流拍 8已成交 9已过户 10待付款 11待提车 12待过户 13 已上架 14 已下架 15 待成交 16下拍
    switch (type) {
        case 1:
            return "待委托";
        case 2:
            return "待保全";
        case 3:
            return "保全失败";
        case 4:
            return "待整备";
        case 5:
            return "待上拍";
        case 6:
            return "上拍";
        case 7:
            return "流拍";
        case 8:
            return "已成交";
        case 9:
            return "已过户";
        case 10:
            return "待交款";
        case 11:
            return "待提车";
        case 12:
            return "待过户";
        case 13:
            return "已上架";
        case 14:
            return "已下架";
        case 15:
            return "待成交";
        case 16:
            return "下拍";
        default:
            return '/'
    }
}

/**
 * 显示押金状态
 * 0未退、1已退，显示押金状态是已退还是未退。
 */
export const DEPOSITSTATUS = (type) => {
    const numType = Number(type)
    switch (numType) {
        case 0:
            return "未退";
        case 1:
            return "已退";
        default:
            return '/'
    }
}

/**
 * 竞拍类型
 * 1普通 2一口价 3期车 4专场
 */
export const AUCTIONTYPE = (type) => {
    const numType = Number(type)
    switch (numType) {
        case 1:
            return "普通";
        case 2:
            return "一口价";
        case 3:
            return "期车";
        case 4:
            return "专场";
        default:
            return '/'
    }
}

/**
 * 保险公司
 * 　
 太平财险
 大地财险
 黄河财险
 珠峰财险
 永安财险
 燕赵财险
 中煤财险
 国寿财险
 人保财险
 平安财险
 中华财险
 阳光财险
 大家财险
 国任财险
 天平财险
 华农财险
 紫金财险
 永城财险
 富德财险
 泰山财险
 中银财险
 出口信用
 中路保险
 英大财险
 太平洋财险
 锦泰财险
 华安财险
 华泰财险
 渤海财险
 都帮财险
 众诚财险
 安诚财险
 天安财险
 亚太财险
 泰康在线
 鼎和财险
 恒邦财险
 合众财险
 诚泰财险

 */
export const INSURANCECOMPANY = [
    {
        label: "太平财险",
        value: "太平财险",
    },
    {
        label: "大地财险",
        value: "大地财险",
    },
    {
        label: "黄河财险",
        value: "黄河财险",
    },
    {
        label: "珠峰财险",
        value: "珠峰财险",
    },
    {
        label: "永安财险",
        value: "永安财险",
    },
    {
        label: "燕赵财险",
        value: "燕赵财险",
    },
    {
        label: "中煤财险",
        value: "中煤财险",
    },
    {
        label: "国寿财险",
        value: "国寿财险",
    },
    {
        label: "人保财险",
        value: "人保财险",
    },
    {
        label: "平安财险",
        value: "平安财险",
    },
    {
        label: "中华财险",
        value: "中华财险",
    },
    {
        label: "阳光财险",
        value: "阳光财险",
    },
    {
        label: "大家财险",
        value: "大家财险",
    },
    {
        label: "国任财险",
        value: "国任财险",
    },
    {
        label: "天平财险",
        value: "天平财险",
    },
    {
        label: "华农财险",
        value: "华农财险",
    },
    {
        label: "紫金财险",
        value: "紫金财险",
    },
    {
        label: "永城财险",
        value: "永城财险",
    },
    {
        label: "富德财险",
        value: "富德财险",
    },
    {
        label: "泰山财险",
        value: "泰山财险",
    },
    {
        label: "中银财险",
        value: "中银财险",
    },
    {
        label: "出口信用",
        value: "出口信用",
    },
    {
        label: "中路保险",
        value: "中路保险",
    },
    {
        label: "英大财险",
        value: "英大财险",
    },
    {
        label: "太平洋财险",
        value: "太平洋财险",
    },
    {
        label: "锦泰财险",
        value: "锦泰财险",
    },
    {
        label: "华安财险",
        value: "华安财险",
    },
    {
        label: "华泰财险",
        value: "华泰财险",
    },
    {
        label: "渤海财险",
        value: "渤海财险",
    },
    {
        label: "都帮财险",
        value: "都帮财险",
    },
    {
        label: "众诚财险",
        value: "众诚财险",
    },
    {
        label: "安诚财险",
        value: "安诚财险",
    },
    {
        label: "天安财险",
        value: "天安财险",
    },
    {
        label: "亚太财险",
        value: "亚太财险",
    },
    {
        label: "泰康在线",
        value: "泰康在线",
    },
    {
        label: "鼎和财险",
        value: "鼎和财险",
    },
    {
        label: "恒邦财险",
        value: "恒邦财险",
    },
    {
        label: "合众财险",
        value: "合众财险",
    },
    {
        label: "诚泰财险",
        value: "诚泰财险",
    },
]


/**
 * 使用性质
 * 非营运/营运
 */
export const USEPROPERTY = [
    {
        label: "非营运",
        value: "非营运",
    },
    {
        label: "营运",
        value: "营运",
    },
    {
        label: "预约出租车",
        value: "预约出租车",
    },
    {
        label: "营转非",
        value: "营转非",
    },
    {
        label: "货运",
        value: "货运",
    }
]

/**
 * 车所属人
 * 个人/单位
 */
export const CAROWNER = [
    {
        label: "个人",
        value: "个人",
    },
    {
        label: "单位",
        value: "单位",
    }
]


/**
 * 拖车类型
 * 个人/单位
 */
export const TCTYPE = [
    {
        label: "个人",
        value: "个人",
    },
    {
        label: "公司",
        value: "公司",
    }
]

// 关联拍卖会默认数据
export const AUCTIONDEFAULT = {
    carId: null, //车辆id
    auctionType: "",//竞拍类型
    // auctionName: '', //拍卖会场次
    // startingPrice: '', // 起拍价
    auctionId: null,//拍卖会名称
    // reservePrice: '',// 保留价
    // isPopular: '' //热门车辆展示
}

/**
 * 审核状态
 */
// 根据状态值返回对应的标签类型
export const getStatusTagType = (status) => {
    switch (status) {
        case 0:
        case 1:
        case 2:
            return "primary";
        case 3:
            return "success";
        case 4:
            return "danger";
        case 5:
            return "success";
        default:
            return "warning"; // 或者可以返回 'info' 作为默认类型
    }
};
// 根据状态值返回对应的文本
export const getStatusText = (status) => {
    // 假设 agencyAndHeadquarters 是一个根据状态返回文本的函数
    console.log("列表审核状态："+status)
    return agencyAndHeadquarters(status);
};
export const getStatusText2 = (status) => {
    // 假设 agencyAndHeadquarters 是一个根据状态返回文本的函数

    return status===0?"提交":"查看";
};


/**
 * 会员是否交款
 * 0是 1否
 */
export function isPay(status) {
    switch (status) {
        case 0:
            return "是";
        case 1:
            return "否";
        default:
            return "/";
    }
}

/**
 * 保全失败默认数据
 */
export const FAILUREDEFAULT = {
    "carId": null, //车辆id
    "maintainId": null, //保全id
    "isUpload": null, //图片是否上传 0否 1是
    "institutionUserId": null, //保全人员Id
    "maintainTime": null, //保全时间
    "notes": null, //备注
    "maintainFailCause": null, //保全失败原因
    "tailState": "" //总回显状态
}


/**
 * 待付款提交默认数据
 */
export const PAYDEFAULT = {
    "carId": "", //车辆id
    "userId": "", //用户id
    "transferDeposit": "", //过户保证金
    "operatorId": "", //收款操作人 选择保全人
    "paymentTime": "" //交款时间
}

/**
 * 待提车默认数据
 */
export const TAKEDEFAULT = {
    "id": "", //车辆id
    "userId": "", //会员id
    "operatorId": "", //操作人员id
    "deliveryTime": "" //提车时间
}

/**
 * 常规下拉栏
 * 0否 1是
 */
export const YESORNO = [
    {
        label: "否",
        value: 0,
    },
    {
        label: "是",
        value: 1,
    }
]


/**
 * 常规判断是否
 * 1是 2否
 */
export function isYesOrNo(status) {
    switch (status) {
        case 1:
            return "是";
        case 2:
            return "否";
        default:
            return "/";
    }
}

/**
 * 退车主押金类型 0非车主 1车主
 */
export function isOwnerDeposit(status) {
    switch (status) {
        case 0:
            return "车主";
        case 1:
            return "非车主";
        default:
            return "/";
    }
}

/**
 * 保全失败原因
 * 二次事故/事故不符/其他。
 */
export const FAILURE = [
    {
        label: "二次事故",
        value: "二次事故",
    },
    {
        label: "事故不符",
        value: "事故不符",
    },
    {
        label: "其他",
        value: "其他",
    }
]


/**
 * 会员押金状态
 * 1 未冻结 2 已冻结
 */
export function isDepositStatus(status) {
    switch (status) {
        case 1:
            return "未冻结";
        case 2:
            return "已冻结";
    }
}

/**
 * 是否上传支付照片 1 未上传 2 已上传
 * isUploadPaymentPhoto
 */
export function isUploadPaymentPhoto(status) {
    switch (status) {
        case 1:
            return "未上传";
        case 2:
            return "已上传";
        default:
            return "/";
    }
}

/**
 * 权限
 * 总公司/机构/会员/超级管理员
 *
 *  总公司能看到所有的数据。
 机构仅能看到自己所属机构的数据。
 会员仅有报价管理模块的权限，仅能看到分配给自己的数据。
 超级管理员可看到所有的数据，可编辑所有的数据
 */
export const PERMISSION = [
    {
        label: "总公司",
        value: "总公司",
    },
    {
        label: "机构",
        value: "机构",
    },
    {
        label: "会员",
        value: "会员",
    },
    {
        label: "超级管理员",
        value: "超级管理员",
    }
]


/**
 * 0否 1是
 */
export function isTrue(data) {
    if (data == 0) {
        return '否'
    } else if (data == 1) {
        return '是'
    } else {
        return '-'
    }
}

export const carOptions = [
    {label: "待委托", value: 1},
    {label: "待保全", value: 2},
    {label: "保全失败", value: 3},
    {label: "待整备", value: 4},
    {label: "待上拍", value: 5},
    {label: "已上拍", value: 6},
    {label: "待交款", value: 7},
    {label: "待提车", value: 8},
    {label: "待过户", value: 9},
]

/**
 * 会员类型
 * admin 总部
 * vip 内网会员
 * app  APP暗标会员
 */
export function isMemberType(data) {
    if (data == 'admin' || data == 'zb') {
        return '总部'
    } else if (data == 'vip') {
        return '内网会员'
    } else if (data == 'app') {
        return 'APP暗标会员'
    }
}
